
/**
 * SVG representation of the GitHub logo (in color).
 */
const AuthLoginMethodLogoGitHub = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" role="img" aria-hidden="true">
    <path
      fill="#161514"
      fillRule="evenodd"
      d="M18 6C11.37 6 6 11.35 6 17.95c0 5.28 3.44 9.76 8.2 11.34.6.11.83-.26.83-.57L15 26.68c-3.34.73-4.04-1.6-4.04-1.6-.55-1.38-1.34-1.75-1.34-1.75-1.08-.74.09-.72.09-.72 1.2.08 1.84 1.23 1.84 1.23 1.07 1.83 2.8 1.3 3.49 1 .1-.78.42-1.3.76-1.6-2.66-.3-5.47-1.33-5.47-5.91 0-1.3.47-2.37 1.24-3.21-.13-.3-.54-1.52.12-3.16 0 0 1-.32 3.3 1.22a11.53 11.53 0 016 0c2.3-1.54 3.3-1.22 3.3-1.22.66 1.64.24 2.86.12 3.16a4.6 4.6 0 011.23 3.2c0 4.6-2.8 5.61-5.47 5.9.43.37.8 1.1.8 2.22v3.28c0 .32.21.69.82.57A11.96 11.96 0 0030 17.95C30 11.35 24.63 6 18 6z"
      clipRule="evenodd"
    />
  </svg>
);

export default AuthLoginMethodLogoGitHub;
